module.exports = __webpack_public_path__ + "static/media/SO2.0e61c985.jpg";